// extracted by mini-css-extract-plugin
export var registration = "style-module--registration--3a927";
export var registration__bottom = "style-module--registration__bottom--cc677";
export var registration__info = "style-module--registration__info--da0e9";
export var registration__text = "style-module--registration__text--cec4b";
export var registration__textAccent = "style-module--registration__text--accent--a92b0";
export var registration__textLineThrough = "style-module--registration__text--line-through--fc5e4";
export var registration__textSmall = "style-module--registration__text--small--7dd47";
export var registration__textSmall2 = "style-module--registration__text--small-2--c77e1";
export var registration__textSubtitle = "style-module--registration__text--subtitle--5651e";
export var registration__title = "style-module--registration__title--3e2c1";
export var registration__top = "style-module--registration__top--508d2";
export var registration__widget = "style-module--registration__widget--cb251";
export var registration__wrap = "style-module--registration__wrap--0edc1";